module.exports = __webpack_public_path__ + "static/media/search.21f0b1f3.svg";